module.exports = "//static.hsappstatic.net/react-codemirror/static-1.8590/theme/hubspot-canvas-dark.sass"